import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

const Banner = () => {
  return (
    <div className="relative w-full h-fit">
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}
        pagination={{
          el: ".swiper-pagination",
          clickable: false,
          type: "custom",
          renderCustom: function (swiper: any, current: any, total: any) {
            return (
              '<div class="current">' +
              0 +
              current +
              "</div>" +
              '<span id="total" class="total">' +
              0 +
              (current > 3 ? 1 : current + 1) +
              "</span>"
            );
          },
        }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        onBeforeInit={(swiper: any) => {
          if (swiper.params.navigation) {
            swiper.params.navigation.prevEl = document.querySelector(
              ".swiper-button-prev"
            );
            swiper.params.navigation.nextEl = document.querySelector(
              ".swiper-button-next"
            );
          }
          swiper.navigation.update();
        }}
        onAutoplayTimeLeft={(s: any, time: any, progress: number) => {
          const progressLine = document.querySelector<HTMLElement>(".svg");
          progressLine!.style.setProperty(
            "--progress",
            (1 - progress).toString()
          );
        }}
        modules={[Autoplay, Pagination, Navigation]}
        className="bannerSwiper relative w-full h-fit bg-black text-white"
      >
        <SwiperSlide>
          <div className="hidden xl:block">
            <BannerCard id="banner4" src={"/images/banner4.webp"} title=" " />
          </div>
          <div className=" xl:hidden">
            <BannerCard
              id="banner4"
              src={"/images/mo_banner4.webp"}
              title=" "
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <BannerCard
            id="banner1"
            src={"/images/banner1.webp"}
            title="ALL&nbsp;IN&nbsp;ONE FOR&nbsp;FRESH&nbsp;DRIP&nbsp;COFFEE"
          />
        </SwiperSlide>
        <SwiperSlide>
          <BannerCard
            id="banner2"
            src={"/images/banner2.webp"}
            title="Licensed&nbsp;Q&nbsp;Grader&nbsp;Certificate에 검증된&nbsp;생두"
          />
        </SwiperSlide>
        <SwiperSlide>
          <BannerCard
            id="banner3"
            src={"/images/banner3.webp"}
            title="GB&nbsp;EXPLORER&nbsp;SARAH'S&nbsp;COFFEE"
          />
        </SwiperSlide>
        <div className="absolute left-0 bottom-5 w-full h-fit">
          <div className="relative px-[calc((100%-var(--container))/2)] flex items-center gap-5">
            <div className={"progressbox grid items-center"}>
              <div className="absolute flex justify-between bottom-0 left-0 w-full h-full">
                <div className="swiper-pagination !static flex w-full h-full justify-between items-center"></div>
              </div>
              <div className={"autoplayprogress"}>
                <svg className="svg" viewBox="0 0 100 10">
                  <line x1="0" y1="0" x2="100" y2="0" />
                </svg>
              </div>
            </div>
            <div className="flex w-fit h-fit items-center">
              <div className={"swiperbuttonprev swiper-button-prev"}></div>
              <div className={"swiperbuttonnext swiper-button-next"}></div>
            </div>
          </div>
        </div>
      </Swiper>
    </div>
  );
};

export default Banner;

export const BannerCard = ({
  id,
  src,
  title,
}: {
  id: string;
  src: any;
  title: string;
}) => {
  return (
    <div
      id={id}
      className="relative w-full h-[500px] lg:h-[73vh] xl:max-h-[900px] overflow-hidden"
    >
      <img
        id="img"
        className={
          id === "banner4"
            ? `!relative w-full h-full object-cover object-center`
            : `!relative w-full h-full object-cover object-center opacity-50`
        }
        alt="banner3"
        src={src}
        width={3000}
        height={3000}
      />
      <div className="absolute left-0 top-0 w-full h-full z-0">
        <div className="relative px-[calc((100%-var(--container))/2)] w-full h-full grid items-center text-center">
          <div>
            <div className="title1 relative w-fit h-fit mx-auto opacity-0 translate-y-5">
              <p className={"font-serif text-xl lg:text-3xl"}>{title}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
